import axios from 'axios';
import { mainUrl, username, password } from '../../Constants';


Date.prototype.yyyymmdd = function () {
	var mm = this.getMonth() + 1; // getMonth() is zero-based
	var dd = this.getDate();

	return [this.getFullYear(),
	(mm > 9 ? '' : '0') + mm,
	(dd > 9 ? '' : '0') + dd
	].join('');
};

export const SCHEDULE_FETCH_SUCCESS = 'SCHEDULE_FETCH_SUCCESS';

export const scheduleFetchSuccess = scheduleData => ({
	type: SCHEDULE_FETCH_SUCCESS,
	scheduleData
});

export const SCHEDULE_LOADING_ERROR = 'SCHEDULE_LOADING_ERROR';

export const scheduleError = scheduleError => ({
	type: SCHEDULE_LOADING_ERROR,
	scheduleError
});

export const SCHEDULE_IS_LOADING = 'SCHEDULE_IS_LOADING';
export const scheduleLoading = scheduleIsLoading => ({
	type: SCHEDULE_IS_LOADING,
	scheduleIsLoading
});

export const SCHEDULE_SAVE = 'SCHEDULE_SAVE';
export const scheduleSave = event => ({
	type: SCHEDULE_SAVE,
	event
});

export const SCHEDULE_EDIT = 'SCHEDULE_EDIT';
export const scheduleEdit = event => ({
	type: SCHEDULE_EDIT,
	event
});

export const SCHEDULE_DELETE = 'SCHEDULE_DELETE';
export const scheduleDelete = event => ({
	type: SCHEDULE_DELETE,
	event
});

export function scheduleFetchData(accountId) {
	return (dispatch) => {
		dispatch(scheduleLoading(true));
		axios(mainUrl + "accounts/" + accountId + "/scheduledEvents?offset=" + new Date().getTimezoneOffset() + "&forDate=" + new Date(Date.now()).yyyymmdd())
			.then((response) => {

				if (response.status !== 200) {
					throw Error(response.statusText);
				}
				dispatch(scheduleLoading(false));
				return response;
			})
			.then((items) => {
				dispatch(scheduleFetchSuccess(items.data));

			}
			)
			.catch(() => dispatch(scheduleError(true)));
	};
}



// WEBPACK FOOTER //
// ./src/Store/Actions/SchedulerActions.js